import { FC } from 'react';
import styled from 'styled-components';
import { CenterSpace } from '../GenericCssComponentMatchMobile';
import type { Match } from '../../../../../types';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding: 0 10px;
    row-gap: 2px;

    & h6 {
        font-size: 6px;
        font-weight: 500;
        color: white;
        text-align: center;
        margin: 0;
        padding: 0;
    }
`;

const TopInfoFight = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;

`;

const BoxBelt = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;

    & .belt-img {
        max-height: 30px;
        max-width: 100%;
        object-fit: contain;
        object-position: center;
    }
`;

interface CenterInfoFightRenderingProps {
    matchInfo: Match;
    typeMatch: string;
}

const CenterInfoFightRendering: FC<CenterInfoFightRenderingProps> = ({ matchInfo, typeMatch }) => {
    return (
        <CenterSpace className='center-space'>
            <Wrapper className='wrapper-center-info-fight'>

            <TopInfoFight className='top-info-fight'>
                <h6 className='type-match'>{typeMatch}</h6>
                <h6 className='name-match'>{matchInfo.type_match?.name}</h6>
            </TopInfoFight>

                {matchInfo.belt && (
                    <BoxBelt className='box-belt-img'>
                        <img
                            src={process.env.REACT_APP_STORAGE_URL + matchInfo.belt.img_path}
                            alt={matchInfo.belt.name}
                            className='belt-img'
                        />
                        <h6 className='name-match'>{matchInfo.belt.name}</h6>
                    </BoxBelt>
                )}

            </Wrapper>
        </CenterSpace>

    )
}

export default CenterInfoFightRendering;
